"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _withTheme = require("../../wrappers/with-theme");

var _Item = _interopRequireDefault(require("./Item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MobileMenu = function MobileMenu(_ref) {
  var open = _ref.open,
      _ref$menuItems = _ref.menuItems,
      menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
      customTheme = _ref.customTheme;
  var theme = Object.assign({}, (0, _withTheme.useTheme)(), customTheme);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(open ? 'sm:hidden relative' : 'hidden', " ").concat(theme.menuBg)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-2 pb-3"
  }, menuItems.map(function (page, i) {
    return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: i,
      to: page.path,
      icon: page.icon,
      theme: theme
    }, page.name);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-4 pb-3 border-t border-gray-200"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-3",
    role: "menu",
    "aria-orientation": "vertical",
    "aria-labelledby": "user-menu"
  })));
};

var DesktopMenu = function DesktopMenu(_ref2) {
  var _ref2$menuItems = _ref2.menuItems,
      menuItems = _ref2$menuItems === void 0 ? [] : _ref2$menuItems,
      open = _ref2.open,
      toggle = _ref2.toggle,
      fixed = _ref2.fixed,
      width = _ref2.width,
      logo = _ref2.logo,
      rightMenu = _ref2.rightMenu,
      _ref2$customTheme = _ref2.customTheme,
      customTheme = _ref2$customTheme === void 0 ? false : _ref2$customTheme;
  var theme = Object.assign({}, (0, _withTheme.useTheme)(), customTheme);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(theme.topNavHeight || 'h-16', "  ").concat(theme.sidebarBg, "  ").concat(theme.topMenuBorder, " ").concat(theme.topMenuScroll)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(theme.contentWidth, " flex justify-between ").concat(theme.topNavHeight ? theme.topNavHeight : 'h-16')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: '/',
    className: "flex-shrink-0 flex items-center ".concat(theme.text)
  }, logo), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden sm:-my-px sm:ml-6 sm:flex"
  }, menuItems.map(function (page, i) {
    return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: i,
      to: page.path,
      icon: page.icon,
      customTheme: customTheme,
      type: "top"
    }, page.name);
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-2 flex items-center sm:hidden"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: toggle,
    className: "inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: "".concat(open ? 'hidden' : 'block', " h-6 w-6"),
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M4 6h16M4 12h16M4 18h16"
  })), /*#__PURE__*/_react["default"].createElement("svg", {
    className: "".concat(open ? 'block' : 'hidden', " h-6 w-6"),
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M6 18L18 6M6 6l12 12"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden sm:block lg:ml-4"
  }, rightMenu ? rightMenu : '')));
};

var _default = function _default(props) {
  var theme = Object.assign({}, (0, _withTheme.useTheme)(), props.customTheme);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1]; //clickedOutside = React.useCallback(() => setOpen(false), []),
  //[setRef] = useClickOutside(clickedOutside),
  //theme = useTheme()


  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: "".concat(theme.menuBg, " ").concat(theme.topNavHeight ? theme.topNavHeight : 'h-16', "  ").concat(theme.sidebarBorder)
  }, /*#__PURE__*/_react["default"].createElement(DesktopMenu, _extends({
    toggle: function toggle(e) {
      // console.log('toggle menu', open)
      return setOpen(!open);
    }
  }, props, {
    open: open
  })), /*#__PURE__*/_react["default"].createElement(MobileMenu, _extends({}, props, {
    open: open
  })));
};

exports["default"] = _default;